import { where, documentId } from 'firebase/firestore';
import { addDataToTable, deleteDocById } from '../utils';

export const addRequest = async (request, setLoading) =>
  addDataToTable({ tableName: 'requests', data: request, setLoading });

export const rejectRequest = async (id, setLoading) =>
  deleteDocById({ tableName: 'requests', id, setLoading });
